export function getQueryParam(name: string): string | null {
  const url = new URL(window.location.href)
  return url.searchParams.get(name)
}

export function isIOS(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent)
}

export function isMobile(): boolean {
  return isIOS() || isAndroid()
}

export function hasAppInstalled(): boolean {
  // On mobile devices, we'll attempt app redirect first
  // On desktop, we'll show the service page with download links
  return isMobile()
}
